<template>
    <div class="main">
        <!-- 頁首 -->
        <Header :title="title" :isBack="true" />

        <!-- 主體 -->
        <div class="mainContent">
            <b-tabs style="height:100%;">
                <!--
                <b-tab title="訂閱作物" active>
                    訂閱作物內容
                </b-tab>
                -->
                <b-tab title="交易行情">
                    <!-- 條件選單 -->
                    <b-container fluid class="pb-3">
                        <!-- 標題 -->
                        <PwaTitle :textTitle="trading_quotes.text" :showMore="false"></PwaTitle>
                        <div class="w3-row">
                            <!-- 種類 -->
                            <div class="w3-col w3-container m4 l4">
                                <p>
                                    <label class="global-descript">{{ trading_quotes.input.type.text }}</label>
                                    <v-select class="global-descript" v-model="trading_quotes.input.type.value" :options="trading_quotes.input.type.list" :reduce="(option) => option.value" label="text"></v-select>
                                </p>
                            </div>
                            <!-- 產品名稱 -->
                            <div class="w3-col w3-container m4 l4">
                                <p>
                                    <label class="global-descript">{{ trading_quotes.input.product.text }}</label>
                                    <v-select class="global-descript" v-model="trading_quotes.input.product.value" :options="trading_quotes.input.product.list" :reduce="(option) => option.value" label="text"></v-select>
                                </p>
                            </div>
                            <!-- 市場 -->
                            <div class="w3-col w3-container m4 l4">
                                <p>
                                    <label class="global-descript">{{ trading_quotes.input.market.text }}</label>
                                    <v-select class="global-descript" v-model="trading_quotes.input.market.value" :options="trading_quotes.input.market.list" :reduce="(option) => option.value" label="text"></v-select>
                                </p>
                            </div>
                        </div>
                    </b-container>
                    <!-- 價格資訊 -->
                    <b-container fluid class="pb-3">
                        <!-- 標題 -->
                        <PwaTitle :textTitle="trading_quotes.trade_day.text" :showMore="false"></PwaTitle> 
                        
                        <!-- 交易日期 -->
                        <div class="w3-col w3-margin-bottom" style="width:33.33%">
                            <ul class="w3-ul w3-border w3-center w3-hover-shadow">
                                <li class="global-descript">{{ trading_quotes.trade_day.date.text }}</li>
                                <li class="global-descript"> &nbsp; <b>{{ trading_quotes.trade_day.date.value }}</b></li>
                            </ul>
                        </div>
                        <!-- 均價 -->
                        <div class="w3-col w3-margin-bottom" style="width:33.33%">
                            <ul class="w3-ul w3-border w3-center w3-hover-shadow">
                                <li class="global-descript">{{ trading_quotes.trade_day.price_avg.text }}</li>
                                <li class="global-descript">NT＄<b>{{ trading_quotes.trade_day.price_avg.value }}</b></li>
                            </ul>
                        </div>
                        <!-- 交易量 -->
                        <div class="w3-col w3-margin-bottom" style="width:33.33%">
                            <ul class="w3-ul w3-border w3-center w3-hover-shadow">
                                <li class="global-descript">{{ trading_quotes.trade_day.volume.text }}</li>
                                <li class="global-descript"><b>{{ trading_quotes.trade_day.volume.value }}</b> (公斤)</li>
                            </ul>
                        </div>
                        <!-- 上價 -->
                        <div class="w3-col w3-margin-bottom" style="width:33.33%">
                            <ul class="w3-ul w3-border w3-center w3-hover-shadow">
                                <li class="global-descript">{{ trading_quotes.trade_day.price_c.text }}</li>
                                <li class="global-descript">NT＄<b>{{ trading_quotes.trade_day.price_c.value }}</b></li>
                            </ul>
                        </div>
                        <!-- 中價 -->
                        <div class="w3-col w3-margin-bottom" style="width:33.33%">
                            <ul class="w3-ul w3-border w3-center w3-hover-shadow">
                                <li class="global-descript">{{ trading_quotes.trade_day.price_m.text }}</li>
                                <li class="global-descript"><b>NT＄</b> {{ trading_quotes.trade_day.price_m.value }}</li>
                            </ul>
                        </div>
                        <!-- 下價 -->
                        <div class="w3-col w3-margin-bottom" style="width:33.33%">
                            <ul class="w3-ul w3-border w3-center w3-hover-shadow">
                                <li class="global-descript">{{ trading_quotes.trade_day.price_f.text }}</li>
                                <li class="global-descript"><b>NT＄</b> {{ trading_quotes.trade_day.price_f.value }}</li>
                            </ul>
                        </div> 
                        <p>&nbsp;</p>
                        <p>&nbsp;</p>
                        <p>&nbsp;</p>
                        <p>&nbsp;</p>
                        <p>&nbsp;</p>
                        <p>&nbsp;</p>
                        <p>&nbsp;</p>       
                    </b-container>
                </b-tab>
                <b-tab title="價量分析">
                    <!-- 條件選單 -->
                    <b-container fluid class="pb-3">
                        <!-- 標題 -->
                        <PwaTitle :textTitle="price_volume.text" :showMore="false"></PwaTitle>
                        <div class="w3-row">
                            <!-- 種類 -->
                            <div class="w3-col w3-container m4 l4">
                                <p>
                                    <label class="global-descript">{{ price_volume.input.type.text }}</label>
                                    <v-select class="global-descript" v-model="price_volume.input.type.value" :options="price_volume.input.type.list" :reduce="(option) => option.value" label="text"></v-select>
                                </p>
                            </div>
                            <!-- 產品名稱 -->
                            <div class="w3-col w3-container m4 l4">
                                <p>
                                    <label class="global-descript">{{ price_volume.input.product.text }}</label>
                                    <v-select class="global-descript" v-model="price_volume.input.product.value" :options="price_volume.input.product.list" :reduce="(option) => option.value" label="text"></v-select>
                                </p>
                            </div>
                            <!-- 市場 -->
                            <div class="w3-col w3-container m4 l4">
                                <p>
                                    <label class="global-descript">{{ price_volume.input.market.text }}</label>
                                    <v-select class="global-descript" v-model="price_volume.input.market.value" :options="price_volume.input.market.list" :reduce="(option) => option.value" label="text"></v-select>
                                </p>
                            </div>
                        </div>
                    </b-container>
                    <!-- 相關圖表 -->
                    <b-container fluid class="pb-3">
                        <!-- 標題 -->
                        <PwaTitle :textTitle="price_volume.week.text" :showMore="false"></PwaTitle> 
                        <!-- 簡述 -->
                        <div class="global-descript" v-html="price_volume.week.descript"></div>
                        <!-- 圖表 -->
                        <div class="w3-row" style="overflow-x: auto; overflow-y: hidden;" >
                            <div id="chart_trading_quotes_week"></div>
                        </div>
                        <!-- 標題 -->
                        <PwaTitle :textTitle="price_volume.month.text" :showMore="false"></PwaTitle>
                        <!-- 簡述 -->
                        <div class="global-descript" v-html="price_volume.month.descript"></div>
                        <!-- 圖表 -->
                        <div class="w3-row" style="overflow-x: auto; overflow-y: hidden;" >
                            <div id="chart_price_volume_month"></div>
                        </div>
                        <!-- 標題 -->
                        <PwaTitle :textTitle="price_volume.year.text" :showMore="false"></PwaTitle>
                        <!-- 簡述 -->
                        <div class="global-descript" v-html="price_volume.year.descript"></div>
                        <!-- 圖表 -->
                        <div class="w3-row" style="overflow-x: auto; overflow-y: hidden;" >
                            <div id="chart_price_volume_year"></div>
                        </div>
                    </b-container>    
                </b-tab>
                <b-tab title="養殖面積">
                    <!-- 條件選單 -->
                    <b-container fluid class="pb-3">
                        <!-- 標題 -->
                        <PwaTitle :textTitle="fishery_area.text" :showMore="false"></PwaTitle>
                        <div class="w3-row">
                            <!-- 種類 -->
                            <div class="w3-col w3-container m4 l4">
                                <p>
                                    <label class="global-descript">{{ fishery_area.input.type.text }}</label>
                                    <v-select class="global-descript" v-model="fishery_area.input.type.value" :options="fishery_area.input.type.list" :reduce="(option) => option.value" label="text"></v-select>
                                </p>
                            </div>
                            <!-- 產品名稱 -->
                            <div class="w3-col w3-container m4 l4">
                                <p>
                                    <label class="global-descript">{{ fishery_area.input.product.text }}</label>
                                    <v-select class="global-descript" v-model="fishery_area.input.product.value" :options="fishery_area.input.product.list" :reduce="(option) => option.value" label="text"></v-select>
                                </p>
                            </div>
                        </div>
                    </b-container>
                    <!-- 相關圖表 -->
                    <b-container fluid class="pb-3">
                        <!-- 標題 -->
                        <PwaTitle :textTitle="'養殖面積-成魚養成'" :showMore="false"></PwaTitle> 
                        <!-- 沒有資料 -->
                        <div class="contentBlock shadow-sm" v-show="fishery_area.fishery_area.is_result && fishery_area.fishery_area.list.length == 0">
                            <div class="global-descript">沒有養殖面積</div>
                        </div>
                        <!-- 圖表 -->
                        <div class="w3-row" style="overflow-x: auto; overflow-y: hidden;" v-show="fishery_area.fishery_area.is_result && fishery_area.fishery_area.list.length > 0">
                            <div id="chart_fishery_area_fishery_area"></div>
                        </div>
                        <!-- 標題 -->
                        <PwaTitle :textTitle="'養殖面積-第一類(有水權)'" :showMore="false"></PwaTitle> 
                        <!-- 沒有資料 -->
                        <div class="contentBlock shadow-sm" v-show="fishery_area.fishery_area2.is_result && fishery_area.fishery_area2.list.length == 0">
                            <div class="global-descript">沒有養殖面積</div>
                        </div>
                        <!-- 圖表 -->
                        <div class="w3-row" style="overflow-x: auto; overflow-y: hidden;" v-show="fishery_area.fishery_area2.is_result && fishery_area.fishery_area2.list.length > 0">
                            <div id="chart_fishery_area_fishery_area2"></div>
                        </div> 
                        <!-- 標題 -->
                        <PwaTitle :textTitle="fishery_area.fishery_production.year + '年漁業總產量'" :showMore="false"></PwaTitle> 
                        <div class="w3-row" style="overflow-x: auto; overflow-y: hidden;" v-show="fishery_area.fishery_production.is_result">
                            <div id="chart_fishery_area_fishery_production"></div>
                        </div>
                        <!-- 標題 -->
                        <PwaTitle :textTitle="fishery_area.fishery_production_value.year + '年漁業總產值'" :showMore="false"></PwaTitle> 
                        <div class="w3-row" style="overflow-x: auto; overflow-y: hidden;" v-show="fishery_area.fishery_production_value.is_result">
                            <div id="chart_fishery_area_fishery_production_value"></div>
                        </div>

                    </b-container>
                </b-tab>
            </b-tabs> 
        </div>

    </div>
</template>
<script>
import Header from '@/components/pwa/Header.vue'
import PwaTitle from '@/components/pwa/PwaTitle.vue'
export default {
    created() {
        window.vue = this; 
        if(!window.checkLogin()){ window.setPage("login");}                 
    },  
    components: {
        Header,
        PwaTitle,
    },
    data(){
        return {
            title: "漁業情報站",

            //當日交易行情
            trading_quotes:{
                id:"trading_quotes",
                text:"當日交易行情",
                //表單物件
                input:{
                    //種類
                    type:{
                        text:"種類",
                        value:"",
                        placeholder:"請選擇種類",
                        list:[],
                    },
                    //產品名稱
                    product:{
                        text:"產品名稱",
                        value:"",
                        placeholder:"請選擇產品名稱",
                        list:[],
                    },
                    //市場
                    market:{
                        text:"市場",
                        value:"",
                        placeholder:"請選擇市場",
                        list:[],
                    }
                }, 
                //當日交易行情
                trade_day:{
                    text:"作物近期交易資訊",
                    //是否有結果
                    is_result:false,
                    //交易日期
                    date:{
                        text:"交易日期",
                        value:""
                    },
                    //上價(元/公斤)
                    price_c:{
                        text:"上價",
                        value:0
                    },
                    //中價(元/公斤)
                    price_m:{
                        text:"中價",
                        value:0
                    },
                    //下價(元/公斤)
                    price_f:{
                        text:"下價",
                        value:0
                    },
                    //均價(元/公斤)
                    price_avg:{
                        text:"均價",
                        value:0
                    },
                    //交易量(公斤)
                    volume:{
                        text:"交易量",
                        value:0
                    },
                },
            },
            //價量變化分析
            price_volume:{
                id:"price_volume",
                text:"價量變化分析",
                //表單物件
                input:{
                    //種類
                    type:{
                        text:"種類",
                        value:"",
                        placeholder:"請選擇種類",
                        list:[],
                    },
                    //產品名稱
                    product:{
                        text:"產品名稱",
                        value:"",
                        placeholder:"請選擇產品名稱",
                        list:[],
                    },
                    //市場
                    market:{
                        text:"市場",
                        value:"",
                        placeholder:"請選擇市場",
                        list:[],
                    }
                },
                //一周(近七日)交易行情
                week:{
                    //是否有結果
                    is_result:false, 
                    text:"一周交易均價變化圖",
                    descript:"近7日交易均價及成交量。"
                },
                //月交易均價分析圖
                month:{
                    //是否有結果
                    is_result:false, 
                    text:"月交易均價分析圖",
                    descript:"近12個月交易均價及成交量。"
                },
                //年交易均價分析圖
                year:{                       
                    //是否有結果
                    is_result:false, 
                    text:"年交易均價分析圖",
                    descript:"近5年交易均價及成交量。"  
                },
            },
            fishery_area:{
                id:"fishery_area",
                text:"漁業養殖面積",
                //表單物件
                input:{
                    //種類
                    type:{
                        text:"種類",
                        value:"",
                        placeholder:"請選擇種類",
                        list:[],
                    },
                    //產品名稱
                    product:{
                        text:"產品名稱",
                        value:"",
                        placeholder:"請選擇產品名稱",
                        list:[],
                    }
                },
                //魚塭面積(公頃)-成魚養成
                fishery_area:{
                    
                    //是否有結果
                    is_result:false, 
                    //產品
                    fish:"",
                    //清單
                    list:[],
                },
                //魚塭面積(公頃)-第一類(有水權)
                fishery_area2:{

                    //是否有結果
                    is_result:false,
                    //產品
                    fish:"", 
                    //清單
                    list:[],
                },

                //漁業總產量
                fishery_production:{

                    //是否有結果
                    is_result:false,
                    //年度
                    year:"",  
                },
                //漁業總產值
                fishery_production_value:{

                    //是否有結果
                    is_result:false,
                    //年度
                    year:"",  
                }
            },

            //api 取得漁業情報站預設值(網頁剛載入時，預設選取)
            apiGetIntelligenceFishery: (data) => this.userRequest.post("/API/Default/GetIntelligenceFishery", data),

            //api 取得種類(該選項相對應的資訊)
            apiGetTradeFisheryTypeInfo: (data) => this.userRequest.post("/API/Default/GetTradeFisheryTypeInfo", data),

            //api 取得產品名稱(該選項相對應的資訊)
            apiGetTradeFisheryProductInfo: (data) => this.userRequest.post("/API/Default/GetTradeFisheryProductInfo", data),

            //api 取得市場名稱(該選項相對應的資訊)
            apiGetTradeFisheryMarketInfo: (data) => this.userRequest.post("/API/Default/GetTradeFisheryMarketInfo", data),
        
        }
    },
    watch: {

        //當日交易行情-種類
        "trading_quotes.input.type.value":function(val)
        {
            console.log(val);
            if(!this.default_load)
            {
                this.trading_quotes.trade_day.is_result = false;
                this.getTradingQuotesTypeInfo();
            }  
        },
        //當日交易行情-產品名稱
        "trading_quotes.input.product.value":function(val)
        {
            console.log(val);
            if(!this.default_load)
            {
                this.trading_quotes.trade_day.is_result = false;
                this.getTradingQuotesProductInfo();
            }
        },
        //當日交易行情-市場
        "trading_quotes.input.market.value":function(val)
        {
            console.log(val);
            if(!this.default_load)
            {
                this.trading_quotes.trade_day.is_result = false;
                this.getTradingQuotesMarketInfo();
            }
        },

        //價量變化分析-種類
        "price_volume.input.type.value":function(val)
        {
            console.log(val);
            if(!this.default_load)
            {
                this.price_volume.week.is_result = false;
                this.price_volume.month.is_result = false;
                this.price_volume.year.is_result = false;
                this.getPriceVolumeTypeInfo();
            }
        },
        //價量變化分析-產品名稱
        "price_volume.input.product.value":function(val)
        {
            console.log(val);
            if(!this.default_load)
            {
                this.price_volume.week.is_result = false;
                this.price_volume.month.is_result = false;
                this.price_volume.year.is_result = false;
                this.getPriceVolumeProductInfo();
            }
        },
        //價量變化分析-市場
        "price_volume.input.market.value":function(val)
        {
            console.log(val);
            if(!this.default_load)
            {
                this.price_volume.week.is_result = false;
                this.price_volume.month.is_result = false;
                this.price_volume.year.is_result = false;
                this.getPriceVolumeMarketInfo()
            }
        },

        //漁業養殖面積-種類
        "fishery_area.input.type.value":function(val)
        {
            console.log(val);
            if(!this.default_load)
            {
                this.fishery_area.fishery_area.is_result = false;
                this.fishery_area.fishery_area2.is_result = false;
                this.fishery_area.fishery_production.is_result = false;
                this.fishery_area.fishery_production_value.is_result = false;
                this.getFisheryAreaTypeInfo();
            }
        },
        
        //漁業養殖面積-產品名稱
        "fishery_area.input.product.value":function(val)
        {
            console.log(val);
            if(!this.default_load)
            {
                this.fishery_area.fishery_area.is_result = false;
                this.fishery_area.fishery_area2.is_result = false;
                this.fishery_area.fishery_production.is_result = false;
                this.fishery_area.fishery_production_value.is_result = false;
                this.getFisheryAreaProductInfo(); 
            }
        },


    },
    mounted() {

        this.getIntelligenceFishery();
    },
    destroyed() {},
    methods: {

        //啟用遮罩
        enableDefaultLoad:function()
        {
            this.enableMask();
            this.default_load = true;
        },
        //取消遮罩
        disableDefaultLoad:function()
        { 
            //暫時先設定延遲，否則watch會重複觸發
            const _this = this;
            window.ThreadTool.Delay(function(){
            
                _this.disableMask();
                _this.default_load = false;

            },this.delay_ms_api);
        },

        //設定當日交易行情-種類
        setTradingQuotesInputType:function(TradeFisheryType)
        {
            //當日交易行情-種類
            this.trading_quotes.input.type.value = "";
            this.trading_quotes.input.type.list = [];
            if(TradeFisheryType.length > 0)
            {
                for(var i=0 ; i<TradeFisheryType.length ; i++)
                {
                    //當日交易行情-種類
                    this.trading_quotes.input.type.list.push({value:TradeFisheryType[i].FISH_TYPE,text:TradeFisheryType[i].FISH_TYPE});
                } 
            }
        },
        //設定價量變化分析-種類
        setPriceVolumeInputType:function(TradeFisheryType)
        {
            //價量變化分析-種類
            this.price_volume.input.type.value = "";
            this.price_volume.input.type.list = [];
            if(TradeFisheryType.length > 0)
            {
                for(var i=0 ; i<TradeFisheryType.length ; i++)
                {
                    //價量變化分析-種類
                    this.price_volume.input.type.list.push({value:TradeFisheryType[i].FISH_TYPE,text:TradeFisheryType[i].FISH_TYPE});
                } 
            }
        },
        //設定漁業養殖面積-種類
        setCropAreaInputType:function(TradeFisheryType)
        {
            //漁業養殖面積-種類
            this.fishery_area.input.type.value = "";
            this.fishery_area.input.type.list = [];
            if(TradeFisheryType.length > 0)
            {
                for(var i=0 ; i<TradeFisheryType.length ; i++)
                {
                    //漁業養殖面積-種類
                    this.fishery_area.input.type.list.push({value:TradeFisheryType[i].FISH_TYPE,text:TradeFisheryType[i].FISH_TYPE});
                } 
            }
        },
        
        //設定當日交易行情-產品名稱
        setTradingQuotesInputProduct:function(TradeFisheryName)
        {
            //當日交易行情-產品名稱
            this.trading_quotes.input.product.value = "";
            this.trading_quotes.input.product.list = [];
            if(TradeFisheryName.length > 0)
            {
                for(var i=0 ; i<TradeFisheryName.length ; i++)
                {
                    //當日交易行情-產品名稱
                    this.trading_quotes.input.product.list.push({value:TradeFisheryName[i].FISH_CODE,text:TradeFisheryName[i].FISH});
                }
                this.trading_quotes.input.product.value = TradeFisheryName[0].FISH_CODE;
            }  
        },
        //設定價量變化分析-產品名稱
        setPriceVolumeInputProduct:function(TradeFisheryName)
        {
            //價量變化分析-產品名稱
            this.price_volume.input.product.value = "";
            this.price_volume.input.product.list = [];
            if(TradeFisheryName.length > 0)
            {
                for(var i=0 ; i<TradeFisheryName.length ; i++)
                {
                    //價量變化分析-產品名稱
                    this.price_volume.input.product.list.push({value:TradeFisheryName[i].FISH_CODE,text:TradeFisheryName[i].FISH});
                }
                this.price_volume.input.product.value = TradeFisheryName[0].FISH_CODE;
            }  
        },
        //設定漁業養殖面積產品名稱
        setCropAreaInputProduct:function(TradeFisheryName)
        {
            //漁業養殖面積-產品名稱
            this.fishery_area.input.product.value = "";
            this.fishery_area.input.product.list = [];
            if(TradeFisheryName.length > 0)
            {
                for(var i=0 ; i<TradeFisheryName.length ; i++)
                {
                    //漁業養殖面積-產品名稱
                    this.fishery_area.input.product.list.push({value:TradeFisheryName[i].FISH_CODE,text:TradeFisheryName[i].FISH});
                }
                this.fishery_area.input.product.value = TradeFisheryName[0].FISH_CODE;
            }  
        },

        //設定當日交易行情-市場
        setTradingQuotesInputMarket:function(TradeFisheryMarket)
        {
            //當日交易行情-市場
            this.trading_quotes.input.market.value = "";
            this.trading_quotes.input.market.list = [];
            if(TradeFisheryMarket.length > 0)
            {
                for(var i=0 ; i<TradeFisheryMarket.length ; i++)
                {
                    //當日交易行情-市場
                    this.trading_quotes.input.market.list.push({value:TradeFisheryMarket[i].MARKET,text:TradeFisheryMarket[i].MARKET});
                }  
                this.trading_quotes.input.market.value = TradeFisheryMarket[0].MARKET; 
            }
        },
        //設定價量變化分析-市場
        setPriceVolumeInputMarket:function(TradeFisheryMarket)
        {
            //價量變化分析-市場
            this.price_volume.input.market.value = "";
            this.price_volume.input.market.list = [];
            if(TradeFisheryMarket.length > 0)
            {
                for(var i=0 ; i<TradeFisheryMarket.length ; i++)
                {
                    //價量變化分析-市場
                    this.price_volume.input.market.list.push({value:TradeFisheryMarket[i].MARKET,text:TradeFisheryMarket[i].MARKET});
                }  
                this.price_volume.input.market.value = TradeFisheryMarket[0].MARKET; 
            }      
        },

        //設定當日交易行情-漁業近期交易資訊
        setTradeFisheryDay:function(TradeFisheryDay)
        {
            if(TradeFisheryDay.length > 0)
            {
                var item = TradeFisheryDay[0];
                this.trading_quotes.trade_day.date.value = item.T_DATE;
                this.trading_quotes.trade_day.price_c.value = item.PRICE_C;
                this.trading_quotes.trade_day.price_m.value = item.PRICE_M;
                this.trading_quotes.trade_day.price_f.value = item.PRICE_F;
                this.trading_quotes.trade_day.price_avg.value = item.PRICE_AVG;
                this.trading_quotes.trade_day.volume.value = item.VOLUME; 
                this.trading_quotes.trade_day.is_result = true;
            }
        },
        //設定當日交易行情-一周交易均價變化圖
        setTradeFisheryWeek:function(TradeFisheryWeek)
        {
            if(TradeFisheryWeek.length > 0)
            {
                var column_week = [];
                var line_week = [];
                for(var i=0 ; i<TradeFisheryWeek.length ; i++)
                {
                    column_week.push({
                        //交易日期
                        x:TradeFisheryWeek[i].T_DATE,
                        //交易量
                        y:this.getRounded(TradeFisheryWeek[i].VOLUME)
                    });

                    line_week.push({
                        //交易日期
                        x:TradeFisheryWeek[i].T_DATE,
                        //均價
                        y:this.getRounded(TradeFisheryWeek[i].PRICE_AVG)
                    });
                }

                this.price_volume.week.is_result = true;

                window.ThreadTool.Delay(function(){
        
                    window.setChartIntelligenceTradingQuotesWeek("#chart_trading_quotes_week",{
                        column:column_week,
                        line:line_week
                    });

                },this.delay_ms_chart);
            }
        },

        //設定價量變化分析-月交易均價分析圖
        setTradeFisheryMonth:function(TradeFisheryMonth)
        {
            if(TradeFisheryMonth.length > 0)
            {
                var column_month = [];
                var line_month = [];
                for(var i=0 ; i<TradeFisheryMonth.length ; i++)
                {
                    column_month.push({
                        //交易日期
                        x:TradeFisheryMonth[i].T_YEAR_MONTH,
                        //交易量
                        y:this.getRounded(TradeFisheryMonth[i].VOLUME)
                    });

                    line_month.push({
                        //交易日期
                        x:TradeFisheryMonth[i].T_YEAR_MONTH,
                        //均價
                        y:this.getRounded(TradeFisheryMonth[i].PRICE_AVG)
                    });
                }

                this.price_volume.month.is_result = true;
                window.ThreadTool.Delay(function(){

                    window.setChartIntelligencePriceVolumeMonth("#chart_price_volume_month",{
                        column:column_month,
                        line:line_month
                    });

                },this.delay_ms_chart); 
            }
        },
        //設定價量變化分析-年交易均價分析圖
        setTradeFisheryYear:function(TradeFisheryYear)
        {
            if(TradeFisheryYear.length > 0)
            {
                var column_year = [];
                var line_year = [];
                for(var i=0 ; i<TradeFisheryYear.length ; i++)
                {
                    column_year.push({
                        //交易日期
                        x:TradeFisheryYear[i].T_YEAR,
                        //交易量
                        y:this.getRounded(TradeFisheryYear[i].VOLUME)
                    });

                    line_year.push({
                        //交易日期
                        x:TradeFisheryYear[i].T_YEAR,
                        //均價
                        y:this.getRounded(TradeFisheryYear[i].PRICE_AVG)
                    });
                }

                this.price_volume.year.is_result = true;

                window.ThreadTool.Delay(function(){

                    window.setChartIntelligencePriceVolumeYear("#chart_price_volume_year",{
                        column:column_year,
                        line:line_year
                    });

                },this.delay_ms_chart);

            }
        },

        //設定漁業養殖面積-魚塭面積(公頃)-成魚養成
        setFisheryYear:function(FisheryArea)
        {
            this.fishery_area.fishery_area.list = [];
            if(FisheryArea.length > 0)
            {
                var data_fishery_area = [];
                for(var i=0 ; i<FisheryArea.length ; i++)
                {
                    data_fishery_area.push({
                        //縣市
                        x:FisheryArea[i].City,
                        //養殖面積
                        y:this.getRounded(FisheryArea[i].Value)
                    });
                }

                this.fishery_area.fishery_area.fish = FisheryArea[0].Fish,
                this.fishery_area.fishery_area.is_result = true;
                this.fishery_area.fishery_area.list = data_fishery_area;

                window.ThreadTool.Delay(function(){
        
                    window.setChartIntelligenceTradingQuotesFisheryArea("#chart_fishery_area_fishery_area",{
                        data:data_fishery_area
                    });

                },this.delay_ms_chart);
            }
            else
            {
                this.fishery_area.fishery_area.is_result = true;
            }
        },
        //設定漁業養殖面積-魚塭面積(公頃)-第一類(有水權)
        setFisheryYear2:function(FisheryArea2)
        {
            //漁業養殖面積-魚塭面積(公頃)-第一類(有水權)
            this.fishery_area.fishery_area2.list = [];
            if(FisheryArea2.length > 0)
            {
                var data_fishery_area2 = [];
                for(var i=0 ; i<FisheryArea2.length ; i++)
                {
                    data_fishery_area2.push({
                        //縣市
                        x:FisheryArea2[i].City,
                        //養殖面積
                        y:this.getRounded(FisheryArea2[i].Value)
                    });
                }

                this.fishery_area.fishery_area2.fish = FisheryArea2[0].Fish,
                this.fishery_area.fishery_area2.is_result = true;
                this.fishery_area.fishery_area2.list = data_fishery_area2;

                window.ThreadTool.Delay(function(){

                    window.setChartIntelligenceTradingQuotesFisheryArea2("#chart_fishery_area_fishery_area2",{
                        data:data_fishery_area2,
                    });

                },this.delay_ms_chart);
            }
            else
            {
                this.fishery_area.fishery_area2.is_result = true;
            }

        },

        //設定漁業養殖面積-漁業總產量
        setFisheryProduction:function(FisheryProduction)
        {
            console.log(FisheryProduction);
            if(FisheryProduction.length > 0)
            {
                var data_fishery_production = [];
                for(var i=0 ; i<FisheryProduction.length ; i++)
                {
                    data_fishery_production.push({
                        //縣市
                        x:FisheryProduction[i].CITY,
                        //產量(公噸)
                        y:this.getRounded(FisheryProduction[i].VALUE)
                    });
                }

                this.fishery_area.fishery_production.year = FisheryProduction[0].YEAR,
                this.fishery_area.fishery_production.is_result = true;

                window.ThreadTool.Delay(function(){
                                
                    window.setChartIntelligenceFisheryTradingQuotesFisheryProduction("#chart_fishery_area_fishery_production",{
                        data:data_fishery_production,
                    });
                    
                },this.delay_ms_chart);

            }
            else
            {
                this.fishery_area.fishery_production.is_result = true;
            }
        },

        //設定漁業養殖面積-漁業總產值
        setFisheryProductionValue:function(FisheryProductionValue)
        {
            //漁業養殖面積-漁業總產值
            if(FisheryProductionValue.length > 0)
            {
                var data_fishery_production_value = [];
                for(var i=0 ; i<FisheryProductionValue.length ; i++)
                {
                    data_fishery_production_value.push({
                        //縣市
                        x:FisheryProductionValue[i].CITY,
                        //產量(公噸)
                        y:this.getRounded(FisheryProductionValue[i].VALUE)
                    });
                }

                this.fishery_area.fishery_production_value.year = FisheryProductionValue[0].YEAR,
                this.fishery_area.fishery_production_value.is_result = true;

                window.ThreadTool.Delay(function(){
                                
                    window.setChartIntelligenceFisheryTradingQuotesFisheryProductionValue("#chart_fishery_area_fishery_production_value",{
                        data:data_fishery_production_value,
                    });
                    
                },this.delay_ms_chart);

            }
            else
            {
                this.fishery_area.fishery_production_value.is_result = true;
            }
        },

        //取得漁業情報站預設值
        getIntelligenceFishery:function()
        {
            this.enableDefaultLoad();
            this.apiGetIntelligenceFishery({

                CITY:"雲林縣",
                FISH_TYPE:"魚類",
                FISH_CODE:"1011",
                ANA_C_ID:"436",
                MARKET:"三重",
            })
            .then((res)=>{

                //以下先設定為null，因為會發生換頁時，他非null執行updateOptions會報錯，所以統一初始時，幫他設定Null
                //因為Vue是用元件切換，所以在換頁時，default_chart 並不會重載，只有整個重新整理才會重載，所以換頁時時常會出現錯誤
                window.ChartIntelligenceTradingQuotesFisheryArea = null;
                window.ChartIntelligenceTradingQuotesFisheryArea2 = null;
                window.ChartIntelligenceTradingQuotesWeek = null;
                window.ChartIntelligencePriceVolumeMonth = null;
                window.ChartIntelligencePriceVolumeYear = null;
                window.ChartIntelligenceFisheryTradingQuotesFisheryProduction = null;
                window.ChartIntelligenceFisheryTradingQuotesFisheryProductionValue = null;

                const data = JSON.parse(res.data);
                //當日交易行情-選單-種類
                //價量變化分析-選單-種類
                //漁業養殖面積-選單-種類
                const TradeFisheryType = data.TradeFisheryType;
                //當日交易行情-選單-產品名稱
                //價量變化分析-選單-產品名稱
                //漁業養殖面積-選單-產品名稱
                const TradeFisheryName= data.TradeFisheryName;
                //當日交易行情-選單-市場
                //價量變化分析-選單-市場
                //漁業養殖面積-選單-市場
                const TradeFisheryMarket = data.TradeFisheryMarket;

                //當日交易行情-漁業近期交易資訊
                const TradeFisheryDay = data.TradeFisheryDay;
                //當日交易行情-一周交易均價變化圖
                const TradeFisheryWeek = data.TradeFisheryWeek;
                //價量變化分析-月交易均價分析圖
                const TradeFisheryMonth = data.TradeFisheryMonth;
                //價量變化分析-年交易均價分析圖
                const TradeFisheryYear = data.TradeFisheryYear;
                
                //漁業養殖面積-魚塭面積(公頃)-成魚養成
                const FisheryArea = data.FisheryArea;
                //漁業養殖面積-魚塭面積(公頃)-第一類(有水權)
                const FisheryArea2 = data.FisheryArea2;
                //漁業養殖面積-漁業總產量
                const FisheryProduction = data.FisheryProduction;
                //漁業養殖面積-漁業總產值
                const FisheryProductionValue = data.FisheryProductionValue;

                //設定當日交易行情-種類
                this.setTradingQuotesInputType(TradeFisheryType);
                this.trading_quotes.input.type.value = "魚類";
                //設定價量變化分析-種類
                this.setPriceVolumeInputType(TradeFisheryType);
                this.price_volume.input.type.value = "魚類";
                //設定漁業養殖面積-種類
                this.setCropAreaInputType(TradeFisheryType);
                this.fishery_area.input.type.value = "魚類";

                //設定當日交易行情-產品名稱
                this.setTradingQuotesInputProduct(TradeFisheryName);
                this.trading_quotes.input.product.value = "1011";
                //設定價量變化分析-產品名稱
                this.setPriceVolumeInputProduct(TradeFisheryName);
                this.price_volume.input.product.value = "1011";
                //設定漁業養殖面積-產品名稱
                this.setCropAreaInputProduct(TradeFisheryName);
                this.fishery_area.input.product.value = "1011";

                //設定當日交易行情-市場
                this.setTradingQuotesInputMarket(TradeFisheryMarket);
                this.trading_quotes.input.market.value = "三重";
                //設定價量變化分析-市場
                this.setPriceVolumeInputMarket(TradeFisheryMarket);
                this.price_volume.input.market.value = "三重";
            
                //設定當日交易行情-漁業近期交易資訊
                this.setTradeFisheryDay(TradeFisheryDay);
                //設定當日交易行情-一周交易均價變化圖
                this.setTradeFisheryWeek(TradeFisheryWeek);

                //設定價量變化分析-月交易均價分析圖
                this.setTradeFisheryMonth(TradeFisheryMonth);
                //設定價量變化分析-年交易均價分析圖
                this.setTradeFisheryYear(TradeFisheryYear);

                //設定漁業養殖面積-魚塭面積(公頃)-成魚養成
                this.setFisheryYear(FisheryArea);
                //設定漁業養殖面積-魚塭面積(公頃)-第一類(有水權)
                this.setFisheryYear2(FisheryArea2);

                //設定漁業養殖面積-漁業總產量
                this.setFisheryProduction(FisheryProduction);
                //設定漁業養殖面積-漁業總產值
                this.setFisheryProductionValue(FisheryProductionValue);

                this.disableDefaultLoad();
            })
            .catch((err)=> {
                console.log(err);
                this.disableDefaultLoad();
            });
            
        }, 

        //取得當日交易行情-種類切換時，要呈現的資訊
        getTradingQuotesTypeInfo:function()
        {      
            this.enableDefaultLoad();  
            this.apiGetTradeFisheryTypeInfo({

                FISH_TYPE:this.trading_quotes.input.type.value
            })
            .then((res)=>{

                const data = JSON.parse(res.data);
                console.log(data);

                //當日交易行情-產品名稱
                const TradeFisheryName= data.TradeFisheryName;
                //當日交易行情-市場
                const TradeFisheryMarket = data.TradeFisheryMarket;
                //當日交易行情-漁業近期交易資訊
                const TradeFisheryDay = data.TradeFisheryDay;

                //設定當日交易行情-產品名稱
                this.setTradingQuotesInputProduct(TradeFisheryName);
                //設定當日交易行情-市場
                this.setTradingQuotesInputMarket(TradeFisheryMarket);
            
                //設定當日交易行情-漁業近期交易資訊
                this.setTradeFisheryDay(TradeFisheryDay);

                this.disableDefaultLoad(); 
            })
            .catch((err)=> {
                console.log(err);
                this.disableDefaultLoad();
            });
        
        },
        //取得價量變化分析-種類切換時，要呈現的資訊
        getPriceVolumeTypeInfo:function()
        {      
            this.enableDefaultLoad();  
            this.apiGetTradeFisheryTypeInfo({

                FISH_TYPE:this.price_volume.input.type.value
            })
            .then((res)=>{

                const data = JSON.parse(res.data);
                console.log(data);

                //價量變化分析-產品名稱
                const TradeFisheryName= data.TradeFisheryName;
                //價量變化分析-市場
                const TradeFisheryMarket = data.TradeFisheryMarket;
                //價量變化分析-一周交易均價變化圖
                const TradeFisheryWeek = data.TradeFisheryWeek;
                //價量變化分析-月交易均價分析圖
                const TradeFisheryMonth = data.TradeFisheryMonth;
                //價量變化分析-年交易均價分析圖
                const TradeFisheryYear = data.TradeFisheryYear;

                //設定價量變化分析-產品名稱
                this.setPriceVolumeInputProduct(TradeFisheryName);
                //設定價量變化分析-市場
                this.setPriceVolumeInputMarket(TradeFisheryMarket);
            
                //設定價量變化分析-一周交易均價變化圖
                this.setTradeFisheryWeek(TradeFisheryWeek);
                //設定價量變化分析-月交易均價分析圖
                this.setTradeFisheryMonth(TradeFisheryMonth);
                //設定價量變化分析-年交易均價分析圖
                this.setTradeFisheryYear(TradeFisheryYear);

                this.disableDefaultLoad(); 
            })
            .catch((err)=> {
                console.log(err);
                this.disableDefaultLoad();
            });
        
        },
        //取得漁業養殖面積-種類切換時，要呈現的資訊
        getFisheryAreaTypeInfo:function()
        {      
            this.enableDefaultLoad();  
            this.apiGetTradeFisheryTypeInfo({

                FISH_TYPE:this.fishery_area.input.type.value
            })
            .then((res)=>{

                const data = JSON.parse(res.data);
                console.log(data);

                //漁業養殖面積-選單-產品名稱
                const TradeFisheryName= data.TradeFisheryName;                 
                //漁業養殖面積-魚塭面積(公頃)-成魚養成
                const FisheryArea = data.FisheryArea;
                //漁業養殖面積-魚塭面積(公頃)-第一類(有水權)
                const FisheryArea2 = data.FisheryArea2;
                //漁業養殖面積-漁業總產量
                const FisheryProduction = data.FisheryProduction;
                //漁業養殖面積-漁業總產值
                const FisheryProductionValue = data.FisheryProductionValue;

                //設定漁業養殖面積-產品名稱
                this.setCropAreaInputProduct(TradeFisheryName);

                //設定漁業養殖面積-魚塭面積(公頃)-成魚養成
                this.setFisheryYear(FisheryArea);
                //設定漁業養殖面積-魚塭面積(公頃)-第一類(有水權)
                this.setFisheryYear2(FisheryArea2);

                //設定漁業養殖面積-漁業總產量
                this.setFisheryProduction(FisheryProduction);
                //設定漁業養殖面積-漁業總產值
                this.setFisheryProductionValue(FisheryProductionValue);

                this.disableDefaultLoad(); 
            })
            .catch((err)=> {
                console.log(err);
                this.disableDefaultLoad();
            });
        
        },

        //取得當日交易行情-產品名稱切換時，要呈現的資訊
        getTradingQuotesProductInfo:function()
        {
            this.enableDefaultLoad();
            this.apiGetTradeFisheryProductInfo({

                FISH_CODE:this.trading_quotes.input.product.value
            })
            .then((res)=>{

                const data = JSON.parse(res.data);
                //當日交易行情-市場
                const TradeFisheryMarket = data.TradeFisheryMarket;
                //當日交易行情-漁業近期交易資訊
                const TradeFisheryDay = data.TradeFisheryDay;

                //設定當日交易行情-市場
                this.setTradingQuotesInputMarket(TradeFisheryMarket);
            
                //設定當日交易行情-漁業近期交易資訊
                this.setTradeFisheryDay(TradeFisheryDay);

                this.disableDefaultLoad();
            })
            .catch((err)=> {
                console.log(err);
                this.disableDefaultLoad();
            });
        
        },
        //取得價量變化分析-產品名稱切換時，要呈現的資訊
        getPriceVolumeProductInfo:function()
        {
            this.enableDefaultLoad();
            this.apiGetTradeFisheryProductInfo({

                FISH_CODE:this.price_volume.input.product.value
            })
            .then((res)=>{

                const data = JSON.parse(res.data);
                console.log(data);

                //價量變化分析-市場
                const TradeFisheryMarket = data.TradeFisheryMarket;
                //價量變化分析-一周交易均價變化圖
                const TradeFisheryWeek = data.TradeFisheryWeek;
                //價量變化分析-月交易均價分析圖
                const TradeFisheryMonth = data.TradeFisheryMonth;
                //價量變化分析-年交易均價分析圖
                const TradeFisheryYear = data.TradeFisheryYear;

                //設定價量變化分析-市場
                this.setPriceVolumeInputMarket(TradeFisheryMarket);
            
                //設定價量變化分析-一周交易均價變化圖
                this.setTradeFisheryWeek(TradeFisheryWeek);
                //設定價量變化分析-月交易均價分析圖
                this.setTradeFisheryMonth(TradeFisheryMonth);
                //設定價量變化分析-年交易均價分析圖
                this.setTradeFisheryYear(TradeFisheryYear);

                this.disableDefaultLoad(); 
            })
            .catch((err)=> {
                console.log(err);
                this.disableDefaultLoad();
            });
        
        },       
        //取得漁業養殖面積-產品名稱切換時，要呈現的資訊
        getFisheryAreaProductInfo:function()
        {
            this.addUserActionLog({

                TokenID:sessionStorage.getItem("TokenID"),
                WebPage:"漁業情報站",
                WebAction:"提交",
                ActionMemo:"漁業養殖面積",
                RequestData:JSON.stringify({

                    FISH_CODE:this.fishery_area.input.product.value
                })
            });

            this.enableDefaultLoad();
            this.apiGetTradeFisheryProductInfo({

                FISH_CODE:this.fishery_area.input.product.value
            })
            .then((res)=>{

                const data = JSON.parse(res.data);
                console.log(data);
                
                //漁業養殖面積-魚塭面積(公頃)-成魚養成
                const FisheryArea = data.FisheryArea;
                //漁業養殖面積-魚塭面積(公頃)-第一類(有水權)
                const FisheryArea2 = data.FisheryArea2;
                //漁業養殖面積-漁業總產量
                const FisheryProduction = data.FisheryProduction;
                //漁業養殖面積-漁業總產值
                const FisheryProductionValue = data.FisheryProductionValue;

                //設定漁業養殖面積-魚塭面積(公頃)-成魚養成
                this.setFisheryYear(FisheryArea);
                //設定漁業養殖面積-魚塭面積(公頃)-第一類(有水權)
                this.setFisheryYear2(FisheryArea2);

                //設定漁業養殖面積-漁業總產量
                this.setFisheryProduction(FisheryProduction);
                //設定漁業養殖面積-漁業總產值
                this.setFisheryProductionValue(FisheryProductionValue);

                this.disableDefaultLoad(); 
            })
            .catch((err)=> {
                console.log(err);
                this.disableDefaultLoad();
            });
        
        },  

        //取得當日交易行情-市場切換時，要呈現的資訊
        getTradingQuotesMarketInfo:function()
        {
            this.addUserActionLog({

                TokenID:sessionStorage.getItem("TokenID"),
                WebPage:"漁業情報站",
                WebAction:"提交",
                ActionMemo:"當日交易行情",
                RequestData:JSON.stringify({

                    FISH_CODE:this.trading_quotes.input.product.value,
                    MARKET:this.trading_quotes.input.market.value,
                })
            });

            this.enableDefaultLoad();
            this.apiGetTradeFisheryMarketInfo({
                FISH_CODE:this.trading_quotes.input.product.value,
                MARKET:this.trading_quotes.input.market.value,
            })
            .then((res)=>{

                const data = JSON.parse(res.data);
                //當日交易行情-漁業近期交易資訊
                const TradeFisheryDay = data.TradeFisheryDay;
            
                //設定當日交易行情-漁業近期交易資訊
                this.setTradeFisheryDay(TradeFisheryDay);

                this.disableDefaultLoad();
            })
            .catch((err)=> {
                console.log(err);
                this.disableDefaultLoad();
            });
        
        },
        //取得價量變化分析-市場切換時，要呈現的資訊
        getPriceVolumeMarketInfo:function()
        {
            this.addUserActionLog({

                TokenID:sessionStorage.getItem("TokenID"),
                WebPage:"漁業情報站",
                WebAction:"提交",
                ActionMemo:"價量變化分析",
                RequestData:JSON.stringify({

                    FISH_CODE:this.price_volume.input.product.value,
                    MARKET:this.price_volume.input.market.value,
                })
            });

            this.enableDefaultLoad();
            this.apiGetTradeFisheryMarketInfo({
                FISH_CODE:this.price_volume.input.product.value,
                MARKET:this.price_volume.input.market.value,
            })
            .then((res)=>{

                const data = JSON.parse(res.data);
                console.log(data);

                //價量變化分析-一周交易均價變化圖
                const TradeFisheryWeek = data.TradeFisheryWeek;
                //價量變化分析-月交易均價分析圖
                const TradeFisheryMonth = data.TradeFisheryMonth;
                //價量變化分析-年交易均價分析圖
                const TradeFisheryYear = data.TradeFisheryYear;
                
                //設定價量變化分析-一周交易均價變化圖
                this.setTradeFisheryWeek(TradeFisheryWeek);
                //設定價量變化分析-月交易均價分析圖
                this.setTradeFisheryMonth(TradeFisheryMonth);
                //設定價量變化分析-年交易均價分析圖
                this.setTradeFisheryYear(TradeFisheryYear);

                this.disableDefaultLoad(); 
            })
            .catch((err)=> {
                console.log(err);
                this.disableDefaultLoad();
            });
        
        },



    },
}
</script>